export default __webpack_public_path__ + "static/media/kitchen3-after2.96c55bc8.jpg";